"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsolationValve = void 0;
const Valve_1 = require("./Valve");
const typeName = 'IsolationValve';
class IsolationValve extends Valve_1.Valve {
    constructor(ob) {
        var _a, _b, _c;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.valveState = ob.valveState || false;
        this.image = (_b = ob.image) !== null && _b !== void 0 ? _b : null;
        this.location = (_c = ob.location) !== null && _c !== void 0 ? _c : undefined;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Valve',
            },
            state: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Valve',
            },
            location: {
                type: 'object',
                editable: true,
                label: 'Location',
                name: 'location',
                description: 'Location of  Valve (lat/ long)',
            },
            valveState: {
                type: 'Boolean',
                editable: false,
                label: 'Active Valve',
                name: 'Active Valve',
                description: 'Is the valve active',
            },
            image: {
                type: 'String',
                editable: true,
                label: 'Image',
                name: 'image',
                description: 'Photograph of Valve',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.IsolationValve = IsolationValve;
